import { useCallback, useEffect, useState } from "react";
import {
  Box,
  IconButton,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  Button,
  Pagination,
  Popover,
  MenuList,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { BsSearch } from "react-icons/bs";
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import { useSelector } from "react-redux";
import api from "../../../services/QualityAssurance";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import TableLoader from "../../TableLoader";

export const PendingTable = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  });

  const statusOptions = [
    { value: '', label: 'All' },
    { value: 0, label: 'Not confirmed' },
    { value: 1, label: 'Application Confirmed' },
    { value: 2, label: 'In progress' },
    { value: 3, label: 'Submitted' },
    { value: 4, label: 'Cancelled' },
    { value: 5, label: 'In process' },
    { value: 6, label: 'Declined' },
    { value: 7, label: 'Shortlisted' },
    { value: 8, label: 'Admitted' },
  ];

  const getStatusLabel = (value) => {
  const status = statusOptions.find((s) => String(s.value) === String(value));
  return status ? status.label : "Unknown";
};


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getQAStatus(admToken, user.schoolId, selectedStatus, searchText, pagination.pageSize, pagination.pageNumber);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
        setPagination(prev => ({
          ...prev,
          totalRecords: res.totalRecord,
          totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
          currentPage: res.currentPage || 1
        }));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }, [admToken, user.schoolId, searchText, pagination.pageSize, pagination.pageNumber, selectedStatus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPagination(prev => ({ ...prev, pageNumber: 1 }));
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, pageNumber: newPage }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItemId(item.admissionId);
    setSelectedItem(item);
  };

  console.log(selectedItemId)
  console.log(selectedItem)

  const handleApprove = async (status) => {
    if (!selectedItemId) return;

    try {
      const response = await api.changeAdmissionStatus(
        admToken,
        selectedItemId,
        status
      );

      if (response && response.status === true) {
        fetchData();
        toast.success(response.message || response.data.message);
      } else {
        toast.error(response.message || response.data.message);
      }
    } catch (error) {
      console.error("Approval failed:", error);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: { xs: "start", sm: "space-between" },
            pt: 4,
            pb: 6,
            background: "rgba(103, 30, 120, 0.1)",
            height: "100px",
            pl: { xs: 2.5 },
          }}
        >
          <Box>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}>
              <span className="text-sm font-semibold">Status</span>
              <Select
                sx={{
                  fontFamily: "Gilroy-Regular",
                  border: "1px solid #691e78",
                  borderRadius: "100px",
                  backgroundColor: "#fff",
                  minWidth: 250
                }}
                labelId="status-select-label"
                id="status-select"
                variant="outlined"
                size="small"
                displayEmpty
                value={selectedStatus ?? ''}
                onChange={(e) => {
                  const value = e.target.value === '' ? null : e.target.value;
                  setSelectedStatus(value);
                }}
              >
                {statusOptions.map((status) => (
                  <MenuItem
                    key={status.label}
                    value={status.value}
                    sx={{ fontFamily: "Gilroy-Regular" }}
                  >
                    {status.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box component="form" onSubmit={handleSearchSubmit} sx={{ width: "100%" }}>
            <Search
              sx={{
                width: {
                  lg: "345px",
                  md: "330px",
                  sm: "auto",
                  xs: "auto",
                  pl: { xs: 6 },
                },
              }}
            >
              <SearchIconWrapper>
                <BsSearch />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search by name or admission number..."
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={handleSearchChange}
              />
            </Search>
          </Box>
        </Box>
        <TableContainer>
          <Table
            sx={{
              minWidth: 700,
              fontFamily: "Gilroy-Regular",
              borderRadius: "0",
            }}
            aria-label="customized table"
          >
            <TableHead sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}>
              <TableRow>
                <StyledTableCell>S/N</StyledTableCell>
                <StyledTableCell>Admission No.</StyledTableCell>
                <StyledTableCell>Application Date</StyledTableCell>
                <StyledTableCell>Student Name</StyledTableCell>
                <StyledTableCell>Class</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
              {loading && pagination.pageNumber === 1 ? (
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <TableLoader />
                  </StyledTableCell>
                </StyledTableRow>
              ) : data?.length > 0 ? (
                data?.map((app, index) => {
                  return (
                    <StyledTableRow
                      key={app.admissionId}
                    >
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>{app.admissionNumber}</StyledTableCell>
                      <StyledTableCell>
                        {new Date(app.applicationDate).toLocaleDateString()}
                      </StyledTableCell>
                      <StyledTableCell>
                        {`${app.lastName} ${app.firstName} ${app.middleName || ''}`}
                      </StyledTableCell>
                      <StyledTableCell>{app.class}</StyledTableCell>
                      <StyledTableCell>{getStatusLabel(app.status)}</StyledTableCell>
                      <StyledTableCell>
                        <Link to={`/qualityassurance/admission/${app.phoneNumber}/?tab=1`}>
                          <span className="text-sm p-1.5 border border-[#671E78] rounded-md">View Application</span>
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton onClick={(e) => handleClick(e, app)}>
                          <MoreVertIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    No applications found
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>

          {pagination.totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
              <Pagination
                count={pagination.totalPages}
                page={pagination.currentPage}
                onChange={handlePageChange}
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#671E78',
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'rgba(103, 30, 120, 0.1)',
                  },
                }}
                showFirstButton
                showLastButton
              />
            </Box>
          )}
        </TableContainer>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            bgcolor: "#671E78",
            color: "#fff",
            fontFamily: "Gilroy-Regular",
            px: 3,
          }}
        >
          <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
            <MenuItem onClick={() => handleApprove(6)}>Decline</MenuItem>
            <MenuItem onClick={() => handleApprove(7)}>Shortlist</MenuItem>
            <MenuItem onClick={() => handleApprove(8)}>Admit</MenuItem>
          </MenuList>
        </Box>
      </Popover>
    </Box >
  );
};